import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { UserDto } from '@workspace/data-types';
import { SubscriptionStatusChipComponent } from '../../chips/subscription-status-chip/subscription-status-chip.component';

@Component({
  selector: 'aura-user-subscription-status',
  imports: [SubscriptionStatusChipComponent],
  templateUrl: './subscription-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSubscriptionStatusAuraComponent {
  private readonly router = inject(Router);
  readonly user = input.required<UserDto | null | undefined>();

  navigateToSubscription(): void {
    void this.router.navigate(['/user/settings'], { queryParams: { drawer: 'subscription' } });
  }

  readonly planName = computed(() => {
    const plan = this.user()?.subscription?.plan;
    if (!plan) return null;
    if (typeof plan === 'string' && plan) {
      return plan.charAt(0).toUpperCase() + plan.slice(1);
    }
    if (typeof plan === 'object' && plan !== null) {
      const p = plan as Record<string, unknown>;
      if (typeof p['slug'] === 'string' && p['slug']) {
        return p['slug'].charAt(0).toUpperCase() + p['slug'].slice(1);
      }
      if (typeof p['name'] === 'string' && p['name']) {
        return p['name'];
      }
    }
    return 'Premium';
  });
}
